import ContactForm from "../components/ContactForm"
import Footer from "../components/Footer"
import Header from "../components/Header"
import '../styles/BlogDetails.scss';
import { useParams, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import axios from "axios";
import DOMPurify from 'dompurify';

const SampleBlog = `${process.env.REACT_APP_S3_URL}SampleBlog6.png`;
const BackButton = `${process.env.REACT_APP_S3_URL}left-arrow-back-button.png`;
interface BlogContent {
    body: string;
    bodyTitle: string;
}
interface BlogPost {
    blogId: number;
    postedOn: string;
    mainTitle: string;
    mainBody: string;
    thumbnail: string;
    contentArray: BlogContent[];
    mainTitleKey: string;
}

const BlogDetails = () => {
    const {mainTitleKey} = useParams();
    const navigate = useNavigate();
    const [blogData, setBlogData] = useState<BlogPost>();
      
      
    useEffect(() => {
        axios.get(process.env.REACT_APP_BACKEND_URL + '/api/v1/blogs/' + mainTitleKey)
        .then((response) => {
            console.log(response.data);
            setBlogData(response.data);
        }).catch((error) => {
            console.error('There was an error fetching the blog post!', error);
        });
     }, [mainTitleKey]);


    const BlogInformation = () => {
        return (
            <div className="blog-post">
                {/* Header Section */}
                <div className="back-header"
                onClick={() => navigate('/Resources/Blogs')}
                >
                    <div>
                        <img src={BackButton} alt="Back" />
                    </div>
                    <div className="back-header-name">Blogs</div>
                    <div><span>•</span></div>
                    <div className="back-header-title">{blogData?.mainTitle}</div>
                </div>
                <header className="blog-header">
                    {/* <p className="blog-date">{blogData?.postedOn}</p> */}
                    <h1 className="blog-title">{blogData?.mainTitle}</h1>
                </header>
                
                {/* Introduction Section */}
                <section className="blog-intro">
                    <div
                        dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(blogData?.mainBody || '') }}
                    />
                </section>
                
                {/* Main Image */}
                <div className="blog-image">
                    <img src={blogData?.thumbnail} alt="UPI Lite X Overview" />
                </div>
                
                {/* Content Sections */}
                {
                    blogData?.contentArray.map((content, index) => {
                        return (
                            <section className="blog-section" key={index}>
                                <h2>{content.bodyTitle}</h2>
                                <div
                                    dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(content.body) }}
                                />
                            </section>
                        )
                    })
                }
            </div>
        )   
    }

    return (
        <div>
            <BlogInformation />
            <ContactForm />
            <Footer />
        </div>
    )
}

export default BlogDetails;